import type { WorkflowInboxFilters } from '../types/workflow';

const ENTITY_TYPE = /^[A-Za-z][A-Za-z0-9_]*$/;

export function createDefaultWorkflowFilters(): WorkflowInboxFilters {
  return {};
}

export function normalizeWorkflowFilters(input: {
  entityType?: string;
  status?: WorkflowInboxFilters['status'];
  page?: number;
  pageSize?: number;
}): {
  filters: WorkflowInboxFilters;
  page: number;
  pageSize: number;
} {
  let entityType = input.entityType?.trim() || undefined;
  const status = input.status;
  if (entityType) {
    if (!ENTITY_TYPE.test(entityType)) {
      throw Object.assign(
        new Error('Request type contains invalid characters.'),
        { code: 'VALIDATION_ERROR' },
      );
    }
    entityType = entityType.toUpperCase();
  }

  const page = input.page ?? 1;
  const pageSize = input.pageSize ?? 20;
  if (!Number.isInteger(page) || page <= 0) {
    throw Object.assign(new Error('page must be a positive integer'), {
      code: 'VALIDATION_ERROR',
    });
  }
  if (!Number.isInteger(pageSize) || pageSize <= 0 || pageSize > 100) {
    throw Object.assign(new Error('pageSize must be between 1 and 100'), {
      code: 'VALIDATION_ERROR',
    });
  }

  return {
    filters: {
      ...(entityType ? { entityType } : {}),
      ...(status ? { status } : {}),
    },
    page,
    pageSize,
  };
}
